import React from 'react';
import MasterclassIndex from '../../masterclass/health';

export default function () {
  return (
    <MasterclassIndex
      noFixedVideo
      noExitIntent
      variant="ad"
      entry="sustainability"
      pageTitle="How Your Food Choices Can Help Save The Planet (For Real)"
      pageDescription="Watch the mini-masterclass — airing now for free"
      ogImage="https://cdn.foodrevolution.org/ppp/og/ppp-opengraph-Sustainability-minded-1200x1200-v20221025.jpg"
      shareUrl="https://plantplaybook.foodrevolution.org/masterclass/sustainability/"
      facebookDescription="Learn the number one thing each of us can do to help fight climate change and build a healthier future for life on Earth."
      twitterDescription="Learn the number one thing each of us can do to help fight climate change and build a healthier future for life on Earth."
      twitterImg="https://cdn.foodrevolution.org/ppp/og/ppp-opengraph-Sustainability-minded-1200x675-20221025.jpg"
      pinterestDescription="Learn the number one thing each of us can do to help fight climate change and build a healthier future for life on Earth."
      pinterestImage="https://cdn.foodrevolution.org/ppp/og/ppp-opengraph-Sustainability-minded-1000x1500-20221025.jpg"
    />
  );
}
